var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import merge from 'deepmerge';
import chartUtils from '../../../utils/chart-utils';
import constants from '../../constants';
import buildSeriesData from '../buildData';
import configureTooltip from '../tooltip/main';

var buildMultiAxisConfiguration = function buildMultiAxisConfiguration(chartConfig, seriesConfig, seriesDataObj, customConfig, index) {
    var SeriesType = seriesConfig.SeriesType,
        FieldName = seriesConfig.FieldName,
        YValueField = seriesConfig.YValueField,
        CrumbFieldName = seriesConfig.CrumbFieldName,
        CrumbDisplayFieldName = seriesConfig.CrumbDisplayFieldName,
        PlotSecondaryAxis = seriesConfig.PlotSecondaryAxis,
        ValueFormat = seriesConfig.ValueFormat,
        BaseFormat = seriesConfig.BaseFormat,
        CurrencySymbol = seriesConfig.CurrencySymbol,
        ShowLineMarkers = seriesConfig.ShowLineMarkers,
        ShowLabels = seriesConfig.ShowLabels,
        SmoothCurves = seriesConfig.SmoothCurves,
        FormatConfig = seriesConfig.FormatConfig,
        SeriesName = seriesConfig.SeriesName,
        StackName = seriesConfig.StackName,
        StackIndex = seriesConfig.StackIndex,
        StackOnField = seriesConfig.StackOnField,
        SecondaryAxisCurrencySymbol = seriesConfig.SecondaryAxisCurrencySymbol,
        SecondaryAxisValueFormat = seriesConfig.SecondaryAxisValueFormat,
        Color = seriesConfig.Color;
    var ChartType = chartConfig.ChartType,
        LabelField = chartConfig.LabelField,
        DisplayCount = chartConfig.DisplayCount;


    if (!ValueFormat) ValueFormat = PlotSecondaryAxis ? SecondaryAxisValueFormat || chartConfig.ValueFormat : chartConfig.ValueFormat;
    if (!BaseFormat) BaseFormat = chartConfig.BaseFormat;
    if (!CurrencySymbol && PlotSecondaryAxis) CurrencySymbol = SecondaryAxisCurrencySymbol;
    if (!CurrencySymbol && !PlotSecondaryAxis) CurrencySymbol = chartConfig.CurrencySymbol;

    var seriesType = void 0;
    var COLUMN_WITH_TARGET = 'ColumnWithTarget';
    var multiplicationPointPlacementFactor = 5;
    var basePointPlacementFactor = 2;
    var normalizationPointPlacementFactor = 10;
    var actualPointPadding = 0.4;
    var targetPointPadding = 0.3;
    var defaultPointPadding = 0.1;
    var actualValueZIndex = 2;
    var targetValueZIndex = 1;

    if (!seriesDataObj[SeriesName]) return {};

    var seriesArray = seriesDataObj[SeriesName];
    var pointPlacementValue = void 0;

    if ((ChartType === 'Column' || ChartType === 'Line') && SeriesType === 'Bar') {
        seriesType = 'column';
    } else if (SeriesType === 'Line' && SmoothCurves) {
        seriesType = 'spline';
    } else if (ChartType == 'Waterfall') {
        seriesType = 'waterfall';
    } else if (ChartType === 'ScatterPlot') {
        seriesType = seriesConfig.DrawPolygon === true ? 'polygon' : 'scatter';
    } else if (ChartType === 'ColumnWithTarget') {
        seriesType = 'column';
        var seriesLength = Object.keys(seriesDataObj).length;
        pointPlacementValue = seriesLength === 2 ? 0 : (Math.floor(index / basePointPlacementFactor) * multiplicationPointPlacementFactor - basePointPlacementFactor) / normalizationPointPlacementFactor;
    } else if (ChartType.toLocaleLowerCase() === constants.chartTypes.RADIALBAR) seriesType = 'column';else {
        seriesType = SeriesType.toLowerCase();
    }

    if (seriesType == 'waterfall') {
        FormatConfig = [{
            FormatOption: [{
                Fill: Color ? Color : 'red'
            }],
            FormatRule: 'LessThan',
            FormatValue: 0
        }, {
            FormatOption: [{
                Fill: Color ? Color : 'green'
            }],
            FormatRule: 'GreaterThan',
            FormatValue: 0
        }];
    }

    if (ChartType.toLowerCase() == 'bubble') {
        seriesConfig.SeriesType = ChartType.toLowerCase();
        seriesType = ChartType.toLowerCase();
        ShowLineMarkers = true;
    }
    var yField = YValueField || FieldName;
    var data = buildSeriesData(seriesArray, LabelField, yField, CrumbFieldName, CrumbDisplayFieldName, DisplayCount, FormatConfig, seriesConfig);

    if (seriesType == 'waterfall') {
        var _data$push;

        data.push((_data$push = {
            name: 'Total',
            isSum: true,
            color: Color ? Color : 'black'
        }, _data$push[LabelField] = 'Total', _data$push));
    }

    return merge({
        name: SeriesName,
        type: seriesType,
        stack: StackName,
        stacking: seriesConfig.ShowPercentage ? 'percent' : StackName ? 'normal' : undefined,
        index: StackIndex,
        zIndex: seriesType == 'spline' || seriesType == 'line' ? 9999 : ChartType === COLUMN_WITH_TARGET ? index % 2 ? targetValueZIndex : actualValueZIndex : undefined,
        yAxis: PlotSecondaryAxis ? 1 : 0,
        color: Color,
        marker: {
            enabled: seriesType == 'scatter' || seriesType == 'polygon' || seriesType === 'area' || ShowLineMarkers,
            fillColor: seriesType === 'area' ? 'transparent' : Color
        },
        data: data,
        pointPadding: ChartType === COLUMN_WITH_TARGET ? index % 2 ? targetPointPadding : actualPointPadding : defaultPointPadding,
        pointPlacement: ChartType === COLUMN_WITH_TARGET ? pointPlacementValue : undefined,
        visible: seriesConfig.IsTrendLine ? seriesConfig.ShowTrendLine : !seriesConfig.Hidden,
        enableMouseTracking: !seriesConfig.IsTrendLine,
        showInLegend: !seriesConfig.IsTrendLine,
        lineWidth: seriesConfig.IsTrendLine ? 3 : ['spline', 'line', 'boxplot'].includes(seriesType) ? 2 : null,
        dashStyle: seriesConfig.IsTrendLine ? 'longdash' : ['spline', 'line', 'boxplot'].includes(seriesType) ? 'solid' : null,
        dataLabels: {
            enabled: ShowLabels,
            style: {
                fontWeight: 'unset',
                textOutline: 0
            },
            formatter: function formatter() {
                if (ValueFormat == '%') ValueFormat = '.0%';
                var labelValue = seriesConfig.ShowPercentage && this.total != 0 ? (this.y / this.total * 100).toFixed(1) : this.y;
                var label = chartUtils.format(labelValue, ValueFormat, CurrencySymbol, null, BaseFormat);
                if (this.total != 0) var stackValue = this.y / this.total;

                var stackValueLimit = 0.10;
                if (stackValue != null && stackValue < stackValueLimit) return '';else return label;
            }
        },
        tooltip: configureTooltip(seriesType, _extends({}, seriesConfig, { ValueFormat: ValueFormat, CurrencySymbol: CurrencySymbol }))
    }, customConfig);
};

export default buildMultiAxisConfiguration;